import React from 'react';
import axios from "axios";
import Path from "./config";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import AdminNavFormProfile from './AdminNavFormProfile';


class AssetInfo extends React.Component {
    constructor(props) {
        super(props);
        //for radio onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {
            sbg_property_detail: '',
            apekshaLength: '0',
            NavMenu: false
        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }

        axios.get(Path + 'Suchi_bride_groom_assetinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;

                this.setState({
                    sbg_property_detail: response.sbg_property_detail,
                    apekshaLength: response.sbg_property_detail.length
                })
            }.bind(this))

    }
    propertyHandler = (e) => {
        let data = e.target.value;
        if (data.length > 100) {

        }
        else {
            this.setState({ sbg_property_detail: e.target.value, apekshaLength: data.length });
        }
    }

    submitClick = (e) => {
        e.preventDefault();

        let typee = "asset";
        let tempStr = "sbg_property_detail=" + this.state.sbg_property_detail +
            "&sbg_id=" + this.state.userId +
            "&type=" + typee
        // console.log("wwwwwwwwwwwwwwwwwwwwwwww",tempStr)
        axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
            .then(function (response) {
                // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                if (response.data.status === "updated") {
                    // localStorage.setItem("userId",response.data.sbg_id)
                    if (this.state.admin === "Admin") {
                        this.props.history.push(`/AdminProfile/UploadDoc`);
                    }
                    else {
                        this.props.history.push(`/FormProfile/UploadDoc`);
                    }

                }
                // alert("Updated Successfully");


            }.bind(this))


    }








    render() {
        return (
            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    {/* <span className="pt-3 mx-auto" >वैयक्तिक माहिती </span> */}
                    <form className="row g-3">
                        <div className="col-md-10">
                            <label htmlFor="inputEmail4" className="form-label">मालमत्तेचे विवरण </label>
                            <ReactTransliterate value={this.state.sbg_property_detail}
                                onChange={this.propertyHandler} renderComponent={(props) => <textarea {...props} />} className="textarea form-control align-content-lg-start" placeholder="आपल्याला द्यायचे असेल तरच द्यावे " />
                            <span id="dataLimit"></span><span>{this.state.apekshaLength}/100</span>


                        </div>
                        <div className="col-md-8 text-primary">
                            टीप : <br></br>
                            १) मुलींनी प्रॉपर्टी टाकुच नये <br></br>
                            २) मुलांनी सुध्दा आवश्यकता असेल तरच टाकावे <br></br>
                            ३) प्रॉपर्टी एकदम शॉर्टकट मध्येच टाकावी <br></br>
                        </div>
                        <div className="col-12">
                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                        </div>
                    </form>
                </div>
            </>
        )
    }
}

export default AssetInfo

